module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-search"
  }, [(!_vm.isDataLoaded) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasError) ? _c('div', {
    staticClass: "error-container alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded) ? _c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "customer-search-form sliding-tray",
    class: _vm.formClass
  }, [_c('div', {
    staticClass: "sliding-tray-content"
  }, [_c('div', {
    staticClass: "scope form-group"
  }, [_c('vue-chosen', {
    attrs: {
      "options": _vm.availableScopes
    },
    model: {
      value: (_vm.scope),
      callback: function($$v) {
        _vm.scope = $$v
      },
      expression: "scope"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group customer-search-query-wrapper"
  }, [_c(_vm.searchMode, {
    tag: "component",
    class: _vm.searchClass,
    attrs: {
      "searchSpec": _vm.queryBuilderSpec
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "search-mode btn btn-primary col-xs-3",
    on: {
      "click": function($event) {
        _vm.toggleMode()
      }
    }
  }, [_vm._v(_vm._s(_vm.toggleTo))]), _vm._v(" "), _c('button', {
    staticClass: "search-action btn btn-primary col-xs-3 pull-right",
    on: {
      "click": function($event) {
        _vm.submitSearch()
      }
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('toggle-switch', {
    model: {
      value: (_vm.save.save),
      callback: function($$v) {
        _vm.save.save = $$v
      },
      expression: "save.save"
    }
  }, [_vm._v("Save for Later")])], 1), _vm._v(" "), (_vm.save.save) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.save.name),
      expression: "save.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.save.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.save.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Description:")]), _vm._v(" "), _c('text-area-component', {
    staticClass: "form-control",
    model: {
      value: (_vm.save.description),
      callback: function($$v) {
        _vm.save.description = $$v
      },
      expression: "save.description"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "sliding-tray-toggle",
    on: {
      "click": function($event) {
        _vm.toggleForm()
      }
    }
  }, [_c('span', [_vm._v("Search")])])]), _vm._v(" "), (_vm.hasResults) ? _c('div', {
    staticClass: "customer-search-results"
  }, [_c(_vm.resultDisplay, {
    tag: "component",
    attrs: {
      "data": _vm.results,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "data:remove": _vm.trimResults
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hasResults) ? _c('div', {
    staticClass: "customer-search-no-results"
  }, [_vm._v("\n            0 matching results\n        ")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f331fa5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/CustomerSearch.vue
// module id = 1127
// module chunks = 0